<app-kontable
        id="dt_classification_types"
        title = "{{ 'common.classification_types_title' | translate }}"
        [columns] = "['id', 'name']"
        [titles] = "['common.id', 'common.name']"
        [showInfoButton]="false"
        [showRecoverButton]="false"
        [showGlobalFilter]="false"
        [showDetailsButton]="false"
        [showAddButton]="true"
        [konPermissions]="perm"
        [source]="svc.types"
        (onAdd)="showAddDialog($event)"
        (onEdit)="onEditInline($event)"
        (onRemove)="onDeleteInline($event)">
</app-kontable>

<p-dialog
        *ngIf="svc.editingType"
        [width]="600"
        [(visible)]="svc.editingType"
        [responsive]="true"
        showEffect="fade"
        [modal]="true"
        (onHide)="onDialogHide()"
        [header]="'common.add_classification_types_title' | translate ">
    <app-classification-types-form
            [editingElement]="svc.editingType"
            (onAddElement)="onAdd($event)">
    </app-classification-types-form>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/classification-types/classification-types.component.html